import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const postDiscussion = data => {
  return dispatch => {
    dispatch({ type: "POST_DISCUSSION_LOADING" });
    api
      .discussionPost(data)
      .then(resp => {
        if (data.id) {
          dispatch(postEditSucceeded(resp.data));
        } else {
          dispatch(postNewSucceeded(resp.data));
        }
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFailed());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "PostDiscussionErrorAlertTitle",
          "Virhe keskustelun tallennuksessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const postNewSucceeded = data => ({
  type: "POST_DISCUSSION_SUCCEEDED",
  payload: { discussion: data },
});

const postEditSucceeded = data => ({
  type: "POST_DISCUSSION_EDIT_SUCCEEDED",
  payload: { discussion: data },
});

const operationFailed = () => ({
  type: "POST_DISCUSSION_FAIL",
});
